import React, { Component } from 'react';

export default class Compose extends Component {

  onSubmit(data) {
      data.preventDefault();
      const message = this.refs.txtMessage.value;
      if (message.length === 0) {
          return;
      }
      const messageObj = {
          text: message,
          at: new Date().valueOf()
      }
      this.props.sendMessage(messageObj);
      this.refs.txtMessage.value = "";
      this.refs.txtMessage.focus();
  }

  render() {
    return (
      <div className="compose">
        <form className="compose-form" onSubmit={this.onSubmit.bind(this)}>
          <input
            type="text"
            ref="txtMessage"
            className="compose-input"
            placeholder="Type a message, @name"
          />
        </form>
      </div>
    );
  }
}